import React from 'react'
import cx from 'classnames'
import Swipeable from 'react-swipeable'

import { reportItemViewExpansion } from '../../../../common/analytics/photoduneAnalytics'

import SimilarPhotos from './similarPhotos/similarPhotosContainer'

import NextButton from './navigation/nextButton'
import PrevButton from './navigation/prevButton'
import CloseButton from './navigation/closeButton'
import Preview from './preview'
import Checkout from './checkout'

import styles from './itemDetails.module.css'

class ItemDetails extends React.Component {
  constructor(props) {
    super(props)

    this.state = { selectedItem: props.item }

    this.selectPreviousItem = this.selectPreviousItem.bind(this)
    this.selectNextItem = this.selectNextItem.bind(this)
    this.onItemClick = this.onItemClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const { selectedItem } = this.state
    const { item, selected } = this.props

    if (item.id === selectedItem.id && selectedItem !== nextProps.item) {
      this.setState({ selectedItem: nextProps.item })
    }

    const willBeSelected = !!nextProps.selected

    if (!selected && willBeSelected) {
      this.setState({ selectedItem: item })
      reportItemViewExpansion(item.id.toString())
    }
  }

  selectPreviousItem() {
    const { prevItemId, selectItem } = this.props
    if (prevItemId) {
      selectItem(prevItemId)
    }
  }

  selectNextItem() {
    const { nextItemId, selectItem } = this.props
    if (nextItemId) {
      selectItem(nextItemId)
    }
  }

  onItemClick(event, item) {
    event.preventDefault()
    this.props.fetchItemLicenses(item.id)
    this.setState({ selectedItem: item })
  }

  render() {
    const {
      rank,
      prevItemId,
      nextItemId,
      selected,
      onAddToFavourites,
      licenses,
      itemDetailsClassName,
      location
    } = this.props

    if (!selected) return null

    const { selectedItem } = this.state

    const isInFavourites = selectedItem.ui.isInFavourites

    return (
      <Swipeable
        onSwipedLeft={this.selectNextItem}
        onSwipedRight={this.selectPreviousItem}
        preventDefaultTouchmoveEvent={true}
      >
        <div className={styles.arrow} />
        <div className={cx(styles.itemDetails, itemDetailsClassName)}>
          <div>
            <div className={styles.contentContainer}>
              <Preview
                item={selectedItem}
                rank={rank}
                isInFavourites={isInFavourites}
                onAddToFavourites={onAddToFavourites}
              />
              <Checkout
                item={selectedItem}
                licenses={licenses[selectedItem.id]}
                rank={rank}
                location={location}
              />
            </div>
            <SimilarPhotos
              selectedItem={selectedItem}
              onItemClick={this.onItemClick}
            />
          </div>

          <PrevButton itemId={prevItemId} />
          <NextButton itemId={nextItemId} />

          <CloseButton itemId={this.props.item.id} />
        </div>
      </Swipeable>
    )
  }
}

export default ItemDetails
